import { message } from 'ant-design-vue';

export default {
  namespaced: true,
  state: {
    // 获取代金券信息
    couponData: {},
    user: {},
  },
  actions: {
    /**
     * 获取代金券信息
     */
    async getCoupon({ commit }) {
      // 获取用户session信息
      this.user = JSON.parse(sessionStorage.getItem('user')) || {};
      const resData = await this.$http.post('/hzwmj/person-coupon/getCoupon', {
        personId: this.user.id,
      });
      if (resData.code === 200) {
        const couponData = resData.data;
        commit('save', { couponData });
      } else if (resData.code === 900) {
        message.error(resData.msg);
      } else {
        message.error('系统异常');
      }
    },
  },
  mutations: {
    /**
     * 保存状态
     * @param state
     * @param payload
     */
    save(state, payload) {
      for (let key of Object.keys(payload)) {
        state[key] = payload[key];
      }
    },
  },
};
